import { Grid as MuiGrid, GridProps as MuiGridProps } from '@mui/material';

export const Grid = ({ ...rest }: MuiGridProps) => <MuiGrid {...rest} />;
